export enum PermissionSubject {
  ALL = "all",
  USER = "user",
  ORGANIZATION = "organization",
  PROJECT = "project",
}
